import z from "zod";
export const ApiValidationErrorSchema = z.object({
    statusCode: z.number(),
    error: z.string(),
    issues: z.unknown(),
});
